<section class="title-bar content-padding first-item">
    <div class="wrapper">
      <h2 class="left">Valet {{ (groups.includes('admin') || groups.includes('operation')) ? "Orari Apertura" : groups.includes('expert') ? "Disponibilita" : "" }} Area</h2>
      <br class="clear">
      <p><b>{{expert?.user?.surname}} {{expert?.user?.name}}</b></p>
    </div>
</section>
<section id="schedaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <div class="bulk-add">

            <div class="col-48 grid-element">
                <label for="bulkAddHanldeCheckbox"></label>
                  <label class="original-label" for="bulkAddHanldeCheckbox">
                    <input type="checkbox" id="bulkAddHanldeCheckbox" [(ngModel)]="bulkAddHanldle">
                        OGNI SETTIMANA [Every Week]
                  </label>
            </div>

            <form class="has-cols" [formGroup]="bulkAddForm" *ngIf="!bulkAddHanldle">
                <fieldset>
                    <legend>BULK ADD AVAILABILITY TIME:</legend>
                    <div class="grid-element-full">
                        <div>
                            <div class="offer-products">
                                <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                    <div class="product-q">
                                        <div class="porduct-qty">
                                            <div class="saifu-input">
                                                <label>Start Date</label>
                                                <input type="date" formControlName="startDate">
                                            </div>
                                            <div class="saifu-input">
                                                <label>End Date</label>
                                                <input type="date" formControlName="endDate">
                                            </div>
                                            <div class="saifu-input">
                                                <label for="">Start Time</label>
                                                <input type="time" formControlName="startTime">
                                            </div>
                                            <div class="saifu-input">
                                                <label for="">End Time</label>
                                                <input type="time" formControlName="endTime">
                                            </div>
                                            <div class="col-48 grid-element">
                                                <label for="allDays"></label>
                                                <label class="original-label" for="allDays">
                                                <input type="checkbox" name="available" id="allDays" [(ngModel)]="allDaysCheck" (change)="checkOnlyOne('allDays')" [ngModelOptions]="{standalone: true}">
                                                    Tutti i giorni (All Days)
                                                </label>
                                              </div>
                                              <div class="col-48 grid-element">
                                                <label for="monTofri"></label>
                                                <label class="original-label" for="monTofri">
                                                <input type="checkbox" name="available" id="monTofri" [(ngModel)]="monToFriCheck" (change)="checkOnlyOne('monToFri')" [ngModelOptions]="{standalone: true}">
                                                Da Lunedì a Venerdì (From Monday to Friday)
                                                </label>
                                              </div>
                                              <div class="col-48 grid-element">
                                                <label for="weekend"></label>
                                                <label class="original-label" for="weekend">
                                                <input type="checkbox" name="available" id="weekend" [(ngModel)]="weekendCheck" (change)="checkOnlyOne('weekend')" [ngModelOptions]="{standalone: true}">
                                                Solo Weekend (Only Weekend Saturday and Sunday)
                                                </label>
                                              </div>
                                              <!-- <div class="col-48 grid-element">
                                                <label for="weekly"></label>
                                                <label class="original-label" for="weekly">
                                                <input type="checkbox" name="available" id="weekly" [(ngModel)]="weeklyCheck" (change)="checkOnlyOne('weekly')" [ngModelOptions]="{standalone: true}">
                                                Ogni settimana (Every Week)
                                                </label>
                                              </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br class="clear">
                    <div class="center">
                        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit($event.target)" [disabled]="!bulkAddForm?.valid">
                        Salva<i class="ml-10 far fa-save"></i>
                        </button>
                    </div>
                </fieldset>
            </form>

            <form class="has-cols" [formGroup]="bulkAddForm" *ngIf="bulkAddHanldle">
                <fieldset>
                    <legend>BULK ADD AVAILABILITY TIME:</legend>
                    <div class="grid-element-full">
                        <div>
                            <div class="offer-products">
                                <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                    <div class="product-q">
                                        <div class="porduct-qty">
                                            <div class="saifu-input">
                                                <label>Start Date</label>
                                                <input type="date" formControlName="startDate">
                                            </div>
                                            <div class="saifu-input">
                                                <label>End Date</label>
                                                <input type="date" formControlName="endDate">
                                            </div>
                                            <div class="booking-day-container" *ngFor="let d of weekDays; let i = index">

                                                <div class="col-48 grid-element days-label-container">
                                                    <label for="{{ d }}"></label>
                                                    <label class="original-label" for="{{ d }}">
                                                        <input type="checkbox" id="{{ d }}" [(ngModel)]="days[i].selected" [ngModelOptions]="{standalone: true}">
                                                            {{ d.toUpperCase() }}
                                                    </label>
                                                </div>

                                                <div class="time-range">
                                                    <div class="pr">
                                                        <label for="{{ d }}-start">Start Time</label>
                                                        <input type="time" id="{{ d }}-start" [(ngModel)]="days[i].startTime" [ngModelOptions]="{standalone: true}">
                                                    </div>
                                                    <div class="pl">
                                                        <label for="{{ d }}-end">End Time</label>
                                                        <input type="time" id="{{ d }}-end" [(ngModel)]="days[i].endTime" [ngModelOptions]="{standalone: true}">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br class="clear">
                    <div class="center">
                        <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit($event.target)" [disabled]="!bulkAddForm?.valid">
                        Salva<i class="ml-10 far fa-save"></i>
                        </button>
                    </div>
                </fieldset>
            </form>
        </div>
        <div class="calendar-view">
            <fieldset>
                <legend>CALENDAR:</legend>
                <full-calendar [options]="calendarOptions"></full-calendar>
            </fieldset>
        </div>
    </div>
</section>